<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar dense flat dark class="toolbar">
                <v-toolbar-title>Invoice</v-toolbar-title>
                <v-spacer> </v-spacer>
                <v-btn class="button" @click="add_new = true">
                    Add Invoice
                </v-btn>
            </v-toolbar>
            <v-row v-if="add_new" class="box" justify="center" dense>
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar dense flat dark class="toolbar">
                        <v-btn icon dark @click="add_new=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Add New Invoice</v-toolbar-title>
                        <v-spacer> </v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Invoice Number</b></p>
                    <v-text-field v-model="invoice_number" dense rounded outlined label="Enter Invoice Number" persistent-hint hint="Please Enter Invoice Number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Financial Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Vendor</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="invVendor_id" :items="inventory_vendor_list" item-text="company_name" item-value="id" label="Vendor" outlined persistent-hint hint="Please Select Vendor" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Amount</b></p>
                    <v-text-field v-model="amount" dense rounded outlined label="Enter Amount" type="number" persistent-hint hint="Please Enter Amount"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Tax</b></p>
                    <v-text-field v-model="tax" dense rounded outlined label="Enter Tax" type="number" persistent-hint hint="Please Enter Tax"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Total</b></p>
                    <v-text-field v-model="total" dense rounded outlined label="Enter Total" type="number" persistent-hint hint="Please Enter Total"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <p><b>Date</b></p>
                            <v-text-field dense rounded outlined hint="YYYY/MM/DD format" persistent-hint v-model="invoice_date" label="Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="invoice_date" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><b>File</b></p>
                    <v-file-input prepend-icon="mdi-attachment" label="Upload Attachment if any!" show-size v-model="file" dense outlined rounded></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><b>Isactive</b></p>
                    <v-switch dense label="Isactive ?" v-model="isactive"></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <p><b>Purpose</b></p>
                    <v-textarea outlined v-model="purpose" label="Enter Purpose"></v-textarea>
                </v-col>
                <v-col v-if="invoice_number && ay && amount && tax && total && invoice_date && invVendor_id" cols="12" sm="6" md="6">
                    <v-btn class="button" @click="save()">Save</v-btn>
                </v-col>
            </v-row>
            <br>
             <v-row v-if="edit_invoice" class="box" justify="center" dense>
                <v-col cols="12" sm="12" md="12">
                    <v-toolbar dense flat dark class="toolbar">
                        <v-btn icon dark @click="edit_invoice=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Add New Invoice</v-toolbar-title>
                        <v-spacer> </v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Invoice Number</b></p>
                    <v-text-field v-model="editItem.invoice_number" dense rounded outlined label="Enter Invoice Number" persistent-hint hint="Please Enter Invoice Number"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Financial Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="editItem.academicyear" :items="ay_list" item-text="ay"  label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Vendor</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="editItem.invvendor" :items="inventory_vendor_list" item-text="company_name"  label="Vendor" outlined persistent-hint hint="Please Select Vendor" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Amount</b></p>
                    <v-text-field v-model="editItem.amount" dense rounded outlined label="Enter Amount" type="number" persistent-hint hint="Please Enter Amount"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Tax</b></p>
                    <v-text-field v-model="editItem.tax" dense rounded outlined label="Enter Tax" type="number" persistent-hint hint="Please Enter Tax"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Total</b></p>
                    <v-text-field v-model="editItem.total" dense rounded outlined label="Enter Total" type="number" persistent-hint hint="Please Enter Total"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <p><b>Date</b></p>
                            <v-text-field dense rounded outlined hint="YYYY/MM/DD format" persistent-hint v-model="editItem.invoice_date_edit" label="Date" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="editItem.invoice_date_edit" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><b>File</b></p>
                    <v-file-input prepend-icon="mdi-attachment" label="Upload Attachment if any!" show-size v-model="editItem.file_edit" dense outlined rounded></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><b>Isactive</b></p>
                    <v-switch dense label="Isactive ?" v-model="editItem.isactive"></v-switch>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <p><b>Purpose</b></p>
                    <v-textarea outlined v-model="editItem.purpose" label="Enter Purpose"></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-btn class="button" @click="saveEdit()">Save</v-btn>
                </v-col>
            </v-row>
            <v-data-table :headers="headers" :items="invoice_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                    <v-icon small class="mr-2 v-icon-size" color="success"
                        >mdi-check-circle-outline</v-icon
                    >
                    </span>
                    <span v-else>
                    <v-icon small class="mr-2 v-icon-size" color="error"
                        >mdi-close-circle-outline</v-icon
                    >
                    </span>
                </template>
                 <template v-slot:item.file="{ item }">
                        <span v-if="item.file != ''">
                            <a class="p-2" :href="awspath + item.file" target="blank">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on"> <v-icon color="primary">mdi-eye</v-icon></v-btn>
                                    </template>
                                    <span> View File</span>
                                </v-tooltip>
                            </a>
                            <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                             <v-btn
                                v-if="item.file != null"
                                small
                                v-bind="attrs" v-on="on"
                                outlined
                                icon
                                color="error
                  "
                                @click="deleteInvoiceFile(item)"
                                class="p-2"
                            >
                                <v-icon small color="error" title="Delete Invoice File">delete</v-icon>
                            </v-btn>
                                    </template>
                             <span> Delete File</span>
                                </v-tooltip>
                        </span>
                        <span v-else> -- </span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div>
                            <v-avatar style="" size="25" class="edit-avatar">
                                <v-icon class="edit-v-icon mr-2" @click="edit_item(item)">edit</v-icon>
                            </v-avatar>
                           
                        </div>
                    </template>
            </v-data-table>
            <v-dialog v-model="dialog_delete" persistent max-width="500px">
      <v-card>
        <v-container>
          <v-card class="box">
            <strong>Are you sure you want Delete this file???</strong>
            <v-row justify="center">
              <v-btn class="button" text @click="dialog_delete = false"
                >No</v-btn
              >
              <v-btn class="button" text @click="deletefile()">Yes</v-btn>
            </v-row>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            dialog_delete:false,
            awspath:null,
            add_new: false,
            edit_invoice: false,
            valid: false,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            ay_list: [],
            ay: null,
            inventory_vendor_list: [],
            invVendor_id: null,
            invoice_list: [],
            invoice_number: null,
            amount: null,
            tax: null,
            total: null,
            purpose: null,
            file: null,
            invoice_date: null,
            isactive: true,
            menu: false,
            modal: false,
            menu2: false,
            invoice_id:null,
            editItem:[],
            headers: [
                { text: "Sr. No.", sortable: false, value: "sr_no" },
                { text: "Invoice Number", sortable: false, value: "invoice_number" },
                { text: "Financial Year", sortable: false, value: "academicyear" },
                { text: "Invvendor", sortable: false, value: "invvendor" },
                { text: "Amount In Rs.", sortable: false, value: "amount" },
                { text: "Tax In Rs." , sortable: false, value: "tax" },
                { text: "Total In Rs.", sortable: false, value: "total" },
                { text: "Purpose", sortable: false, value: "purpose" },
                { text: "Invoice Date", sortable: false, value: "invoice_date" },
                { text: "Invoice File", sortable: false, value: "file" },
                { text: "Isactive", sortable: false, value: "isactive" },
                { text: "Edit", sortable: false, value: "action" },
             ]
            
        }),
        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.onLoad();
        },
        methods: {
            deleteInvoiceFile(item)
            {
                this.invoice_id = item.invoice_id
                this.dialog_delete = true
            },
            deletefile(){
                const data = {
                   invoice_id: this.invoice_id
                }
                 this.overlay = true;
                axios
                    .post("InventoryAccountOfficer/deleteInventoryInvoiceFile", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "File Deleted Successfully...");
                            this.onLoad();
                            this.overlay = false;
                           this.dialog_delete = false
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.deletefile = false
                        
                    });
            },
            edit_item(item){
                this.editItem = item
                this.edit_invoice = true
            },
            saveEdit(){
                let formData = new FormData();
                formData.append("file", this.editItem.file_edit);
                formData.append("academicyear", this.editItem.academicyear);
                formData.append("invoice_number", this.editItem.invoice_number);
                formData.append("invvendor", this.editItem.invvendor);
                formData.append("invoice_date", this.editItem.invoice_date_edit);
                formData.append("total", this.editItem.total);
                formData.append("amount", this.editItem.amount);
                formData.append("tax", this.editItem.tax);
                formData.append("isactive", this.editItem.isactive);
                formData.append("purpose", this.editItem.purpose);
                formData.append("invoice_id", this.editItem.invoice_id);
                 this.overlay = true;
                axios
                    .post("InventoryAccountOfficer/editInventoryInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Issue Added Successfully...");
                            this.onLoad();
                            this.overlay = false;
                            this.editItem = [];
                            this.edit_invoice = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fmsg);
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.editItem = [];
                        this.edit_invoice = false;
                        
                    });
            },
            save() {
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("ay", this.ay);
                formData.append("invoice_number", this.invoice_number);
                formData.append("invVendor_id", this.invVendor_id);
                formData.append("invoice_date", this.invoice_date);
                formData.append("total", this.total);
                formData.append("amount", this.amount);
                formData.append("tax", this.tax);
                formData.append("isactive", this.isactive);
                formData.append("purpose", this.purpose);
                this.overlay = true;
                axios
                    .post("InventoryAccountOfficer/saveInventoryInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Issue Added Successfully...");
                            this.onLoad();
                            this.overlay = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "Issue Already Present");
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                            (this.amount = null),
                            (this.tax = null),
                            (this.total = null),
                            (this.purpose = null),
                            (this.file = null),
                            (this.invoice_date = null),
                            (this.invoice_number = null),
                            (this.ay = null),
                            (this.invVendor_id = null);
                            this.add_new = false
                    });
            },
            onLoad() {
                axios
                    .post("InventoryAccountOfficer/getInventoryInvoice")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.ay_list = res.data.ay_list;
                            this.inventory_vendor_list = res.data.inventory_vendor_list;
                            this.invoice_list = res.data.invoice_list;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>

